import { cn } from "../../lib/utils";
import { Button, Icon } from "../../primitives";
import { type ActiveFilter, ActiveFilterEnum } from "./types";

type GlobalSearchFilterTabsProps = {
	activeFilter: ActiveFilter;
	onChange: (filter: ActiveFilter) => void;
	className?: string;
};

export const GlobalSearchFilterTabs = ({
	activeFilter,
	onChange,
	className,
}: GlobalSearchFilterTabsProps) => (
	<div className={cn("flex items-center gap-2", className)}>
		<Button
			data-testid="all-filter-button"
			color={activeFilter === ActiveFilterEnum.ALL ? "primary" : "inverse"}
			onClick={() => onChange(ActiveFilterEnum.ALL)}
			className={cn("whitespace-nowrap", activeFilter === ActiveFilterEnum.ALL && "active-filter")}
		>
			All
		</Button>
		<Button
			data-testid="accounts-filter-button"
			color={activeFilter === ActiveFilterEnum.ACCOUNTS ? "primary" : "inverse"}
			onClick={() => onChange(ActiveFilterEnum.ACCOUNTS)}
			className={cn(
				"whitespace-nowrap",
				activeFilter === ActiveFilterEnum.ACCOUNTS && "active-filter",
			)}
			leadingIcon={<Icon type="building-office-alt" size="mini" />}
		>
			Accounts
		</Button>
		<Button
			data-testid="bond-requests-filter-button"
			color={activeFilter === ActiveFilterEnum.REQUESTS ? "primary" : "inverse"}
			onClick={() => onChange(ActiveFilterEnum.REQUESTS)}
			className={cn(
				"whitespace-nowrap",
				activeFilter === ActiveFilterEnum.REQUESTS && "active-filter",
			)}
			leadingIcon={<Icon type="clipboard" size="mini" />}
		>
			Bond Requests
		</Button>
		<Button
			data-testid="bonds-filter-button"
			color={activeFilter === ActiveFilterEnum.BONDS ? "primary" : "inverse"}
			onClick={() => onChange(ActiveFilterEnum.BONDS)}
			className={cn(
				"whitespace-nowrap",
				activeFilter === ActiveFilterEnum.BONDS && "active-filter",
			)}
			leadingIcon={<Icon type="shield-check" size="mini" />}
		>
			Bonds
		</Button>
	</div>
);
